import {FormattedMessage} from 'react-intl';
import Utils from '../Common/Utils.js';

const getLastBreathingFormResDataAndColor = (dataset) => {

    let formResData = {
        res: "-",
        color: "#767676"
    };
    if((dataset !== undefined)&&(dataset.length > 0)){
        //Set form val
        formResData.res = (Math.round(dataset[dataset.length-1].y*100)/100)

        //Set form val color
        formResData.color = "#21BA45"
    }
    return (formResData);
}


//Function to get last good breathing rate data
const getLastBreathingOxygenRateDataAndColor = (dataset, threshold, threshold2) => {

    let vniResData = {
        res: "-",
        color: "#767676"
    };

    if((dataset !== undefined)&&(dataset.length > 0)){
        //Set breathing rate value
        vniResData.res = dataset[dataset.length-1].y
        //Set breathing rate color
        vniResData.color = Utils.setMeasureColor(dataset[dataset.length-1].y, threshold, 1, 'sup', threshold2);
    }
    return (vniResData);
}

//Function to get last good breathing leak data
const getLastBreathingUsageDataAndColor = (dataset, date_start, date_end) => {

    let localData = {
        res: "-",
        color: "#767676"
    };
    if((dataset !== undefined)&&(dataset.length > 0)){
        let dateStart = new Date(date_start)
        let dateEnd = new Date(date_end)
        let dateData = new Date(dataset[dataset.length-1].x)
        //Check if last data between date ranges
        if (dateStart.getTime() <= dateData.getTime() && dateEnd.getTime() >= dateData.getTime()) {
            //Set breathing rate value
            localData.res = Number(dataset[dataset.length-1].y).toFixed(2)
        }
    }
    return (localData);
}

//Function to get last good breathing leak data
const getLastBreathingLeakDataAndColor = (dataset, threshold, threshold2) => {

    let localData = {
        res: "-",
        color: "#767676"
    };
    if((dataset !== undefined)&&(dataset.length > 0)){
        //Set breathing rate value
        localData.res = dataset[dataset.length-1].y
        //Set breathing rate color
        if (threshold2 === null || threshold2 === undefined) {
            threshold2 = Utils.setDefaultThreshold2("breathing_leak")
        }
        localData.color = Utils.setMeasureColor(dataset[dataset.length-1].y, threshold, 10, 'sup', threshold2); // Set orange value at 10 from threshold or threshold2
    }
    return (localData);
}

//Function to get last good breathing rate data
const getLastBreathingRateDataAndColor = (dataset, threshold, threshold2) => {

    let localData = {
        res: "-",
        color: "#767676"
    };
    if((dataset !== undefined)&&(dataset.length > 0)){
        //Set breathing rate value
        localData.res = dataset[dataset.length-1].y
        //Set breathing rate color
        if (threshold2 === null || threshold2 === undefined) {
            threshold2 = Utils.setDefaultThreshold2("breathing_rate")
        }
        localData.color = Utils.setMeasureColor(dataset[dataset.length-1].y, threshold, 10, 'sup', threshold2); // Set orange value at 10 from threshold or threshold2
    }
    return (localData);
}

//Function to get last good AHI (IAH) data (higher is worse)
const getLastBreathingAhiDataAndColor = (dataset, threshold, threshold2) => {

    let localData = {
        res: "-",
        color: "#767676"
    };
    if((dataset !== undefined)&&(dataset.length > 0)){
        //Set AHI value
        localData.res = dataset[dataset.length-1].y
        //Set AHI color (no relevant lower bound: keep threshold2 very low so it never triggers)
        if (threshold2 === null || threshold2 === undefined) {
            threshold2 = Utils.setDefaultThreshold2("breathing_rate")
        }
        localData.color = Utils.setMeasureColor(dataset[dataset.length-1].y, threshold, 5, 'sup', threshold2); // Set orange band at 5 below threshold
    }
    return (localData);
}



const formatAndMergeBreathingData = (oldBreathingData, newVNIData, newOxiData, newRespiratoryrateData, newRespiratoryleakData, newOxygenflowrateData, selectedDateEnd, lastBreathingUsageDataDate, newRespiratoryAhiData, newRespiratoryLeak95Data) => {
    /****************/
    // !!! Caution with merge of schedules : unlike other data, this one can be modified
    /****************/

    if (typeof(selectedDateEnd) === "string") {
        selectedDateEnd = new Date(selectedDateEnd)
    }
    let local_data = {"niv_schedule": [], "niv_usage":[], "niv_sessions": [], "oxi_schedule": [], "oxi_usage": [], "respiratory_rate": [], "respiratory_leak": [], "oxygen_flow_rate": [], "respiratory_ahi": [], "respiratory_leak95": []};
    let isANewRRDateValue = "";
    let isANewRLDateValue = "";
    let isANewOFRDateValue = "";
    let isANewAHIDateValue = "";
    let isANewL95DateValue = "";

    // copy old data in temporary array
    if (oldBreathingData !== undefined){
        Utils.mergeBasicOldData(oldBreathingData.respiratory_rate, local_data.respiratory_rate)
        Utils.mergeBasicOldData(oldBreathingData.respiratory_leak, local_data.respiratory_leak)
        Utils.mergeBasicOldData(oldBreathingData.oxygen_flow_rate, local_data.oxygen_flow_rate)
        Utils.mergeBasicOldData(oldBreathingData.respiratory_ahi, local_data.respiratory_ahi)
        Utils.mergeBasicOldData(oldBreathingData.respiratory_leak95, local_data.respiratory_leak95)
        Utils.mergeBasicOldData(oldBreathingData.niv_usage, local_data.niv_usage)
        Utils.mergeBasicOldData(oldBreathingData.niv_sessions, local_data.niv_sessions)
        Utils.mergeBasicOldData(oldBreathingData.oxi_usage, local_data.oxi_usage)
                }

    if (newVNIData !== undefined){
        if(newVNIData.length !== 0 && selectedDateEnd.getTime() >= lastBreathingUsageDataDate) {
            local_data.niv_schedule = newVNIData[0].value
            let new_data = []
                let tmp = JSON.parse(newVNIData[0].value)
                new_data = compute_breathing_usage(tmp)
            local_data.niv_usage = new_data
            // keep the raw continuous-usage sessions so the usage graph can plot
            // each session by clock time (not just the daily total)
            local_data.niv_sessions = compute_breathing_sessions(tmp)
        }
    }

    if (newOxiData !== undefined){
        if(newOxiData.length !== 0 && selectedDateEnd.getTime() >= lastBreathingUsageDataDate){
            local_data.oxi_schedule = newOxiData
            let new_data = []
            let tmp = JSON.parse(newOxiData[0].value)
            new_data = compute_breathing_usage(tmp)
            local_data.oxi_usage = new_data
        }
    }

    if (newRespiratoryrateData !== undefined){
        if(newRespiratoryrateData.length !== 0){
            for (var i = newRespiratoryrateData.length-1; i >= 0; i--){        // Find new values and add it
                newRespiratoryrateData[i].eventDate = new Date(newRespiratoryrateData[i].eventDate).setMilliseconds(0)
                isANewRRDateValue = local_data.respiratory_rate.find(xDate => { return xDate.x === new Date(newRespiratoryrateData[i].eventDate).getTime() })
                if(isANewRRDateValue === undefined){
                    local_data.respiratory_rate.push(  {x: new Date(newRespiratoryrateData[i].eventDate).getTime(), y: newRespiratoryrateData[i].value});
                }
            }
        }
    }

    if (newRespiratoryleakData !== undefined){
        if(newRespiratoryleakData.length !== 0){
            for (var i = newRespiratoryleakData.length-1; i >= 0; i--){        // Find new values and add it
                newRespiratoryleakData[i].eventDate = new Date(newRespiratoryleakData[i].eventDate).setMilliseconds(0)
                isANewRLDateValue = local_data.respiratory_leak.find(xDate => { return xDate.x === new Date(newRespiratoryleakData[i].eventDate).getTime() })
                if(isANewRLDateValue === undefined){
                    local_data.respiratory_leak.push(  {x: new Date(newRespiratoryleakData[i].eventDate).getTime(), y: newRespiratoryleakData[i].value});
                }
            }
        }
    }


    if (newOxygenflowrateData !== undefined){
        if(newOxygenflowrateData.length !== 0){
            for (var i = newOxygenflowrateData.length-1; i >= 0; i--){        // Find new values and add it
                newOxygenflowrateData[i].eventDate = new Date(newOxygenflowrateData[i].eventDate).setMilliseconds(0)
                isANewOFRDateValue = local_data.oxygen_flow_rate.find(xDate => { return xDate.x === new Date(newOxygenflowrateData[i].eventDate).getTime() })
                if(isANewOFRDateValue === undefined){
                    local_data.oxygen_flow_rate.push(  {x: new Date(newOxygenflowrateData[i].eventDate).getTime(), y: newOxygenflowrateData[i].value});
                }
            }
        }
    }

    if (newRespiratoryAhiData !== undefined){
        if(newRespiratoryAhiData.length !== 0){
            for (var i = newRespiratoryAhiData.length-1; i >= 0; i--){        // Find new values and add it
                newRespiratoryAhiData[i].eventDate = new Date(newRespiratoryAhiData[i].eventDate).setMilliseconds(0)
                isANewAHIDateValue = local_data.respiratory_ahi.find(xDate => { return xDate.x === new Date(newRespiratoryAhiData[i].eventDate).getTime() })
                if(isANewAHIDateValue === undefined){
                    local_data.respiratory_ahi.push(  {x: new Date(newRespiratoryAhiData[i].eventDate).getTime(), y: newRespiratoryAhiData[i].value});
                }
            }
        }
    }

    if (newRespiratoryLeak95Data !== undefined){
        if(newRespiratoryLeak95Data.length !== 0){
            for (var i = newRespiratoryLeak95Data.length-1; i >= 0; i--){        // Find new values and add it
                newRespiratoryLeak95Data[i].eventDate = new Date(newRespiratoryLeak95Data[i].eventDate).setMilliseconds(0)
                isANewL95DateValue = local_data.respiratory_leak95.find(xDate => { return xDate.x === new Date(newRespiratoryLeak95Data[i].eventDate).getTime() })
                if(isANewL95DateValue === undefined){
                    local_data.respiratory_leak95.push(  {x: new Date(newRespiratoryLeak95Data[i].eventDate).getTime(), y: newRespiratoryLeak95Data[i].value});
                }
            }
        }
    }

    return local_data;
}

const formatScheduleData = (data, granularity) => {

    // Convert array of start dates to string like [{"start":1725087600000, "end":1725091199999},{"start":1725123600000, "end":1725127199999}]
    let local_data = "["
    data.forEach(part => {
        let localStartDate = new Date (part)
        let localEndDate = new Date((localStartDate.getTime() + (((60/granularity) * 60000)-1)) )
        local_data += "{\\\"start\\\":" + localStartDate.getTime() + ", \\\"end\\\":" + localEndDate.getTime() + "},"

    })
    if (data.length>0){
        local_data = local_data.slice(0, -1)    // Remove last ","
                        }
    local_data += "]"
    return local_data;
}


const formatBreathingDataForUpdate = (data) => {

    // Replace [\\] by []
    data.forEach(part_val => {
        if (part_val.label === "niv_schedule" || part_val.label === "oxi_schedule") {
            part_val.value = part_val.value.replaceAll("\\", "")
                        }
                    })
    return data;
}

// return the list of continuous usage sessions ({start, end} timestamps in ms),
// deduplicated and sorted by start date. Unlike compute_breathing_usage (which
// sums durations per day), this keeps each individual session so the usage graph
// can draw one bar per continuous period.
const compute_breathing_sessions = (time_slots) => {

    let sessions = []
    let time_slots_array

    if (typeof(time_slots) === "string") {
        time_slots_array = JSON.parse(time_slots)
    }
    else {
        time_slots_array = time_slots
    }

    if (time_slots_array !== undefined && time_slots_array !== null) {        // Sanitary check

        // delete doublons
        time_slots_array = time_slots_array.filter((value, index, self) =>
          index === self.findIndex((t) => (
            t.start === value.start && t.end === value.end
          ))
        )
        // Sort data by start date
        time_slots_array.sort(function(a,b){
        if ( a.start < b.start ){
            return -1;
        }
        if ( a.start > b.start ){
            return 1;
        }
            return (0)
        });

        time_slots_array.forEach(timeSlot => {
            let start = Number(timeSlot.start)
            let end
            if (timeSlot.end !== undefined && timeSlot.end !== null) {
                end = Number(timeSlot.end)
            }
            else if (timeSlot.duration !== undefined) {
                end = start + (Number(timeSlot.duration) * 60000)   // duration is in minutes
            }
            if (!isNaN(start) && end !== undefined && !isNaN(end) && end > start) {
                sessions.push({start: start, end: end})
            }
        })
    }
    return(sessions)
}

// compute time slots in duration per day
const compute_breathing_usage = (time_slots) => {

    let duration_per_day = []
    let time_slots_array
    
    if (typeof(time_slots) === "string") {
        time_slots_array = JSON.parse(time_slots)
    }
    else {
        time_slots_array = time_slots
    }

    if (time_slots_array !== undefined && time_slots_array !== null) {        // Sanitary check

        // delete doublons
        time_slots_array = time_slots_array.filter((value, index, self) =>
          index === self.findIndex((t) => (
            t.start === value.start && t.end === value.end
          ))
        )
        // Sort data by start date
        time_slots_array.sort(function(a,b){
        if ( a.start < b.start ){
            return -1;
        }
        if ( a.start > b.start ){
            return 1;
        }
            return (0)
        });

        // add slot duration for each day
        time_slots_array.forEach(timeSlot => {
            let dateStart = new Date(timeSlot.start)
            let dateEnd = new Date(timeSlot.end + 1)
            let slot_duration
            if (timeSlot.duration === undefined) {
                slot_duration = (dateEnd.getTime() - dateStart.getTime()) / 3600000
            }
            else {
                slot_duration = timeSlot.duration / 60
            }
            // if day is different from last slot: add a new day
            if (duration_per_day[duration_per_day.length -1] === undefined 
              || (new Date (duration_per_day[duration_per_day.length -1].x).getDay() !== dateStart.getDay())
              || (new Date (duration_per_day[duration_per_day.length -1].x).getMonth() !== dateStart.getMonth())
              )
            {
              let correctedDate = new Date(dateStart.getTime())
              correctedDate.setHours(0)                                                                                             // remove hours to keep only the day
              duration_per_day.push({x:correctedDate.getTime(), y:slot_duration})           // Add a new day with first duration
            }

            // else if same day : add slot duration with previous slots
            else {                                                                                                                                                                                                                  
              duration_per_day[duration_per_day.length -1].y = String(Number(duration_per_day[duration_per_day.length -1].y) + slot_duration)
            }
        })
    }
    return(duration_per_day)
}




//Const to import functions in other files
const BreathingDataManager = {
  formatAndMergeBreathingData,
  formatScheduleData,
  formatBreathingDataForUpdate,
  getLastBreathingOxygenRateDataAndColor,
  getLastBreathingRateDataAndColor,
  getLastBreathingAhiDataAndColor,
  getLastBreathingLeakDataAndColor,
  getLastBreathingUsageDataAndColor,
  getLastBreathingFormResDataAndColor
};

export default BreathingDataManager